// extracted by mini-css-extract-plugin
export var card = "styles-module--card--5f7ec";
export var cardContent = "styles-module--cardContent--b9017";
export var cardHeading = "styles-module--cardHeading--8afe7";
export var cardHeadingIcon = "styles-module--cardHeadingIcon--41600";
export var cardIcon = "styles-module--cardIcon--f913b";
export var cardWrapper = "styles-module--cardWrapper--e9d85";
export var cards = "styles-module--cards--3cd59";